export enum CENTERCOMPONENTS {
  NONE = 'NONE',
  SHIPTABLE = 'SHIPTABLE',
  TARGETSONMAP = 'TARGETSONMAP',
  ROUTES = 'ROUTES',
}
